/* tslint:disable */
/* eslint-disable */
/**
 * Normal.Web.Cms.Website
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export enum ContentWidth {
    Wide = 'Wide',
    Narrow = 'Narrow'
}



